'use client';

import { c as _c } from "react/compiler-runtime";
import useSWR from 'swr';
import UserUnlockedRoom from '@/app/[locale]/(worlds)/profile/components/UserUnlockedRoom';
import { useConfigsContext } from '@/context/ConfigsContext';
import { getVoucherIds, getVoucherRooms, Owner, Room } from '@/services/cms';
import { useTranslations } from 'next-intl';
type CreatorRooms = {
  creator: Owner;
  rooms: Room[];
};
function groupRoomsByCreator(rooms: Room[]): CreatorRooms[] {
  const roomsByCreator = new Map<string, CreatorRooms>();
  for (const room of rooms) {
    const existingCreatorRooms = roomsByCreator.get(room.owner.id);
    if (existingCreatorRooms) {
      existingCreatorRooms.rooms.push(room);
      continue;
    }
    roomsByCreator.set(room.owner.id, {
      creator: room.owner,
      rooms: [room]
    });
  }
  return Array.from(roomsByCreator.values());
}
export default function UserUnlockedRooms() {
  const $ = _c(14);
  const t = useTranslations();
  const {
    store
  } = useConfigsContext();
  const cmsAccountId = store?.profile?.id;
  const htcToken = store?.credentials?.htcToken;
  let t0;
  if ($[0] !== cmsAccountId || $[1] !== htcToken) {
    t0 = () => getVoucherIds(htcToken, cmsAccountId).then(_temp);
    $[0] = cmsAccountId;
    $[1] = htcToken;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data: voucherData
  } = useSWR(htcToken && cmsAccountId ? "getVoucherIds" : null, t0);
  let t1;
  if ($[3] !== voucherData) {
    t1 = async () => {
      const roomPromises = voucherData.map(_temp2);
      const voucherRooms = (await Promise.all(roomPromises)).flat();
      return groupRoomsByCreator(voucherRooms);
    };
    $[3] = voucherData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: unlockedRoomList
  } = useSWR(voucherData ? "getVoucherRooms" : null, t1);
  if (!voucherData || !unlockedRoomList?.length) {
    return null;
  }
  let t2;
  if ($[5] !== t) {
    t2 = t("profile-page.unlocked-rooms-section-title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <h2 className="header-5 md:header-4">{t2}</h2>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== unlockedRoomList) {
    t4 = unlockedRoomList.map(_temp3);
    $[9] = unlockedRoomList;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div id="unlocked" className="relative flex scroll-mt-40 flex-col gap-6 px-4 md:gap-9 md:px-8 lg:px-18">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp3(item_0, index) {
  return <UserUnlockedRoom key={`unlocked-room-${item_0.creator.id}-${index}`} rooms={item_0.rooms} creator={item_0.creator} />;
}
async function _temp2(item) {
  const resRoom = await getVoucherRooms(item.token_source.voucher_id);
  if (resRoom?.status === 200 && resRoom.results?.results) {
    return resRoom.results.results;
  }
  return [];
}
function _temp(res) {
  return res?.results?.result;
}